// extracted by mini-css-extract-plugin
export default {"w-full":"UpgradeToPro_w-full__YTJhe","packages":"UpgradeToPro_packages__9NFg9"};